import type { RouteLineString } from '@sixam/shared/route-core';

type OldTownCanalRoute = Readonly<{
  distanceM: number;
  elevationGainM: number | null;
  geometry: RouteLineString;
  name: string;
  sourceFile: string;
}>;

/**
 * Parsed from the supplied "10km Old Town Canal Run.gpx" fixture.
 *
 * Keeping this route local makes the marketing preview deterministic and
 * independent of a remote route record or a file-picker session.
 */
export const OLD_TOWN_CANAL_ROUTE = {
  distanceM: 10029.764774907302,
  elevationGainM: 47,
  geometry: {
    type: 'LineString',
    coordinates: [
      [100.489533, 13.756323, 11],
      [100.489577, 13.756308, 11],
      [100.489633, 13.756283, 10],
      [100.489532, 13.753686, 11],
      [100.4895, 13.753687, 11],
      [100.489468, 13.752602, 10],
      [100.489454, 13.752572, 10],
      [100.489265, 13.752439, 9],
      [100.489247, 13.752413, 9],
      [100.489242, 13.752297, 9],
      [100.489242, 13.752297, 9],
      [100.489262, 13.752206, 8],
      [100.489349, 13.752213, 9],
      [100.489381, 13.751869, 8],
      [100.489653, 13.749843, 7],
      [100.489716, 13.749542, 8],
      [100.490155, 13.7478, 10],
      [100.490263, 13.747542, 11],
      [100.490723, 13.746745, 9],
      [100.490766, 13.746691, 9],
      [100.490828, 13.74665, 9],
      [100.490879, 13.746639, 9],
      [100.490981, 13.746666, 9],
      [100.491016, 13.746615, 9],
      [100.491016, 13.746615, 9],
      [100.491954, 13.745151, 9],
      [100.493011, 13.744037, 8],
      [100.493237, 13.743776, 8],
      [100.493482, 13.743532, 8],
      [100.493773, 13.743271, 8],
      [100.493955, 13.743159, 8],
      [100.494345, 13.742967, 9],
      [100.494459, 13.742926, 9],
      [100.494645, 13.742867, 9],
      [100.494715, 13.74286, 9],
      [100.494865, 13.742882, 8],
      [100.494923, 13.742807, 9],
      [100.495095, 13.742687, 9],
      [100.496017, 13.742409, 11],
      [100.497232, 13.742011, 12],
      [100.497681, 13.741878, 10],
      [100.497747, 13.741844, 10],
      [100.497855, 13.741735, 8],
      [100.497908, 13.741626, 7],
      [100.497898, 13.741418, 7],
      [100.497746, 13.740966, 7],
      [100.497735, 13.740817, 6],
      [100.497743, 13.740754, 6],
      [100.497855, 13.740573, 4],
      [100.497855, 13.740573, 4],
      [100.497911, 13.740508, 4],
      [100.497932, 13.740443, 3],
      [100.497918, 13.740281, 3],
      [100.496943, 13.737488, 8],
      [100.496805, 13.737362, 7],
      [100.496743, 13.737349, 7],
      [100.496685, 13.737366, 7],
      [100.49658, 13.737453, 7],
      [100.496564, 13.737737, 7],
      [100.496564, 13.737737, 7],
      [100.496564, 13.737726, 7],
      [100.495478, 13.737712, 7],
      [100.495142, 13.737685, 7],
      [100.494852, 13.737615, 7],
      [100.494665, 13.737551, 7],
      [100.494665, 13.737551, 7],
      [100.494635, 13.737541, 7],
      [100.49409, 13.738617, 7],
      [100.493823, 13.738709, 7],
      [100.49383, 13.738732, 7],
      [100.49383, 13.738732, 7],
      [100.493994, 13.739261, 6],
      [100.494002, 13.739325, 6],
      [100.493983, 13.739375, 5],
      [100.493908, 13.73944, 5],
      [100.493986, 13.739613, 3],
      [100.49408, 13.739637, 3],
      [100.49408, 13.739638, 3],
      [100.494083, 13.739638, 3],
      [100.494103, 13.739628, 3],
      [100.494548, 13.73941, 3],
      [100.494687, 13.739273, 2],
      [100.494711, 13.739244, 2],
      [100.494785, 13.739158, 2],
      [100.495003, 13.739117, 1],
      [100.495143, 13.739073, 1],
      [100.495309, 13.73907, 1],
      [100.495977, 13.738886, 3],
      [100.496941, 13.738607, 4],
      [100.496941, 13.738607, 4],
      [100.496877, 13.738506, 4],
      [100.497869, 13.73816, 6],
      [100.497922, 13.738102, 6],
      [100.497894, 13.737905, 7],
      [100.497753, 13.737441, 9],
      [100.497438, 13.737643, 8],
      [100.49758, 13.737829, 7],
      [100.49758, 13.737829, 7],
      [100.497619, 13.73788, 7],
      [100.497686, 13.737964, 6],
      [100.499318, 13.740039, 6],
      [100.499379, 13.740113, 7],
      [100.499792, 13.740604, 9],
      [100.499948, 13.740737, 9],
      [100.50026, 13.740941, 9],
      [100.500297, 13.740909, 9],
      [100.50037, 13.740912, 8],
      [100.500403, 13.740948, 9],
      [100.5004, 13.741019, 9],
      [100.500461, 13.741038, 9],
      [100.500463, 13.741042, 9],
      [100.500463, 13.741042, 9],
      [100.500491, 13.741096, 9],
      [100.500612, 13.741041, 8],
      [100.500652, 13.74111, 9],
      [100.500652, 13.74111, 9],
      [100.500864, 13.741477, 9],
      [100.50162, 13.742698, 8],
      [100.50303, 13.744761, 15],
      [100.503031, 13.744761, 15],
      [100.502768, 13.744903, 15],
      [100.502811, 13.744972, 16],
      [100.502852, 13.74504, 16],
      [100.50312, 13.744897, 15],
      [100.503151, 13.744902, 15],
      [100.503151, 13.744902, 15],
      [100.503347, 13.745182, 18],
      [100.503799, 13.746734, 12],
      [100.503761, 13.746818, 12],
      [100.503834, 13.746876, 12],
      [100.503862, 13.746973, 12],
      [100.503862, 13.746973, 12],
      [100.503873, 13.747012, 12],
      [100.503941, 13.747329, 11],
      [100.50398, 13.747514, 11],
      [100.504036, 13.74778, 11],
      [100.504078, 13.747943, 11],
      [100.504078, 13.747943, 11],
      [100.504162, 13.748275, 10],
      [100.504313, 13.748949, 9],
      [100.504327, 13.749012, 9],
      [100.504353, 13.749096, 9],
      [100.50439, 13.749083, 9],
      [100.50448, 13.749054, 9],
      [100.504638, 13.749012, 9],
      [100.504638, 13.749012, 9],
      [100.504701, 13.749004, 9],
      [100.504837, 13.749512, 10],
      [100.504968, 13.750199, 9],
      [100.505456, 13.752175, 10],
      [100.505969, 13.754095, 9],
      [100.506208, 13.755141, 8],
      [100.506216, 13.755263, 8],
      [100.506301, 13.755272, 8],
      [100.506301, 13.755272, 8],
      [100.506361, 13.755279, 9],
      [100.506737, 13.755247, 10],
      [100.507522, 13.755032, 10],
      [100.508462, 13.754709, 9],
      [100.50925, 13.75466, 9],
      [100.509288, 13.754656, 9],
      [100.50929, 13.754616, 9],
      [100.509292, 13.754576, 9],
      [100.509407, 13.754566, 9],
      [100.509507, 13.754558, 9],
      [100.50952, 13.754609, 9],
      [100.509565, 13.754606, 9],
      [100.509987, 13.754477, 9],
      [100.510687, 13.754349, 7],
      [100.511357, 13.754288, 7],
      [100.512408, 13.754059, 8],
      [100.513502, 13.753748, 8],
      [100.513634, 13.753753, 8],
      [100.513759, 13.753727, 7],
      [100.513905, 13.753638, 7],
      [100.515023, 13.753462, 15],
      [100.516278, 13.753196, 10],
      [100.516832, 13.753078, 7],
      [100.516832, 13.753078, 7],
      [100.516278, 13.753196, 10],
      [100.516194, 13.752901, 10],
      [100.516692, 13.75275, 8],
      [100.517083, 13.752662, 8],
      [100.51705, 13.752064, 9],
      [100.51695, 13.750934, 11],
      [100.517035, 13.75092, 11],
      [100.516998, 13.750623, 11],
      [100.516856, 13.749467, 11],
      [100.516879, 13.749433, 11],
      [100.516771, 13.748863, 9],
      [100.516743, 13.74882, 9],
      [100.516431, 13.746956, 10],
      [100.516495, 13.746945, 10],
      [100.516475, 13.746832, 10],
      [100.516501, 13.746745, 10],
      [100.516298, 13.74543, 8],
      [100.516269, 13.745036, 8],
      [100.516304, 13.744952, 8],
      [100.516292, 13.744864, 8],
      [100.516385, 13.74485, 8],
      [100.516117, 13.743116, 8],
      [100.516016, 13.74238, 6],
      [100.515949, 13.741816, 7],
      [100.515915, 13.741362, 6],
      [100.515948, 13.741243, 6],
      [100.515958, 13.740839, 5],
      [100.515962, 13.740682, 5],
      [100.515978, 13.740607, 5],
      [100.516018, 13.740547, 5],
      [100.516163, 13.7404, 5],
      [100.516243, 13.740288, 5],
      [100.516257, 13.740229, 5],
      [100.516242, 13.740005, 5],
      [100.516168, 13.739409, 7],
      [100.516192, 13.739236, 7],
      [100.516258, 13.739146, 8],
      [100.516255, 13.739059, 8],
      [100.516193, 13.738722, 8],
      [100.516192, 13.738659, 8],
      [100.516219, 13.738609, 8],
      [100.516491, 13.73857, 7],
      [100.516485, 13.738533, 7],
      [100.516485, 13.738527, 7],
      [100.516484, 13.738518, 7],
      [100.516482, 13.738499, 7],
      [100.516479, 13.738467, 7],
      [100.516448, 13.738451, 7],
      [100.516441, 13.73824, 7],
      [100.516455, 13.738197, 8],
      [100.516472, 13.738198, 7],
      [100.516463, 13.738149, 8],
      [100.516459, 13.738127, 8],
      [100.516381, 13.73805, 9],
      [100.516294, 13.738073, 10],
      [100.516264, 13.737998, 10],
      [100.516248, 13.737959, 11],
      [100.516229, 13.737943, 11],
      [100.516195, 13.737914, 12],
      [100.516223, 13.737851, 12],
      [100.516207, 13.737751, 12],
      [100.516026, 13.737436, 15],
      [100.515991, 13.737181, 14],
      [100.51599, 13.73686, 11],
      [100.516109, 13.735841, 6],
      [100.516119, 13.735624, 7],
      [100.516103, 13.734595, 9],
      [100.515962, 13.73374, 10],
      [100.515846, 13.733246, 10],
      [100.515797, 13.733254, 10],
      [100.515782, 13.733195, 10],
      [100.515789, 13.733145, 10],
      [100.515619, 13.732485, 9],
      [100.515522, 13.732196, 9],
      [100.515376, 13.731851, 9],
      [100.515376, 13.731851, 9],
      [100.515355, 13.731826, 9],
      [100.515306, 13.731824, 9],
      [100.515023, 13.731932, 9],
      [100.514953, 13.731977, 10],
      [100.514917, 13.732027, 10],
      [100.514887, 13.732108, 10],
    ],
  },
  name: '10KM OLD TOWN CANAL RUN',
  sourceFile: '10km Old Town Canal Run.gpx',
} as const satisfies OldTownCanalRoute;
